/**
 * The only screen anyone sees signed out: one shared security code for the console.
 *
 * The code is posted and forgotten - what comes back is an HttpOnly cookie this page
 * cannot read, so there is nothing here to keep in state, in storage, or in a URL.
 */

import { useState } from "react";
import { post } from "../api";
import { Button, inputClass } from "../ui";

export function LoginPage({ onSignedIn }: { onSignedIn: () => void }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!code || busy) return;
    setBusy(true);
    setError(null);
    try {
      await post("/v1/auth/login", { code });
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error && err.message ? err.message : "That code is not right");
      setCode("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-ground px-6">
      <form
        onSubmit={submit}
        className="flex flex-col gap-4 w-full max-w-[22rem] bg-paper border border-line rounded-card px-6 py-7"
      >
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-[16px] tracking-[0.01em]">Demo creator</div>
          <div className="text-[13px] text-muted">Enter the security code to continue.</div>
        </div>
        <input
          className={inputClass}
          type="password"
          autoFocus
          autoComplete="current-password"
          spellCheck={false}
          placeholder="Security code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        {error && <div className="text-[13px] text-warn">{error}</div>}
        <Button kind="primary" type="submit" disabled={!code || busy} className="justify-center">
          {busy ? "Checking…" : "Continue"}
        </Button>
      </form>
    </div>
  );
}
